module.exports = __webpack_public_path__ + "static/media/credit.ade79797.png";